import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import { FormattedMessage } from "react-intl";

const OutboundBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const bannerType = "warning";

  return (
    <div>
      {showBanner ? (
        <Row
          widths={["grid-12"]}
          spacingInset="medium large none large"
          alignmentHorizontal="center"
        >
          <Alert
            size="medium"
            type={bannerType}
            onClose={() => setShowBanner(false)}
          >
            {/* Preference goes to to iI8n/*.json for all languages, if blank there, then defaultMessage is used */}
            <FormattedMessage
              id="outbound.banner"
              defaultMessage="The XPT filter functionality has been changed. You need to select Parent DS also so see it routes"
            />
          </Alert>
        </Row>
      ) : null}
    </div>
  );
};

export default OutboundBanner;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/OutboundBanner.js